import { testResultsActionTypes } from './Constants';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import * as chapterDetailsActions from '../chapterDetails/Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as testResultsAction from './Actions';

export default function* () {
	yield all([
		takeLatest(testResultsActionTypes.GET_ANSWERS, handleAnswersRequest),
		takeLatest(testResultsActionTypes.GET_RESULTS_DETAILS, handleResultsDetailsRequest),
		takeLatest(testResultsActionTypes.GET_RESULTS, handleResultsRequest),
		takeLatest(testResultsActionTypes.GET_TOPIC_ANSWERS, handleTopicAnswersRequest),
	]);
}

export function* handleResultsDetailsRequest(action) {
	try {
		const { testResultsId, eventSource } = action.payload;
		const { data } = yield call(processRequest, `exercises/${testResultsId}/result`, 'GET', {
			source: eventSource,
		});

		yield put(testResultsAction.getResultsDetailsSuccess(data.exercise));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleAnswersRequest(action) {
	try {
		const { testResultsId } = action.payload;
		const { data } = yield call(processRequest, `exercises/${testResultsId}/questions`);

		yield put(testResultsAction.getAnswersSuccess(data.questions));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleResultsRequest({ payload }) {
	try {
		const { testResultsId, query } = payload || {};
		const { data } = yield call(
			processRequest,
			`public/exercises/${testResultsId}/paragraphs`,
			'GET',
			query,
		);

		yield put(testResultsAction.getResultsSuccess(data.paragraphs));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'content-blocking'));
		yield put(chapterDetailsActions.getToDoTopicsError());
	}
}

export function* handleTopicAnswersRequest({ payload }) {
	const { exerciseId, topicId, query } = payload || {};
	try {
		const { data } = yield call(
			processRequest,
			`public/exercises/${exerciseId}/questions`,
			'GET',
			{ topic_id: topicId, ...query },
		);

		yield put(testResultsAction.getTopicAnswersSuccess(topicId, data.questions));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(testResultsAction.getTopicAnswersError(topicId, e));
	}
}
